export const getisLoading = ({ careers }) => careers.loading;

export const getIsErrorInJobDetails = ({ careers }) => careers.error;

export const getCMSDataDescription = ({ careers }) =>
  careers.data?.description ?? '';
